import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c('toolbar',{attrs:{"mode":"report","title":"Create","view":"list"}}),_c('report-form',{attrs:{"working":_vm.working},on:{"submit":_vm.onSubmit,"cancel":function($event){return _vm.$router.push({ name: 'reportList' })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }